module.exports = __webpack_public_path__ + "static/media/our-core-values.e363d39c.png";